// extracted by mini-css-extract-plugin
export default {"ticketsStatusContent":"TicketsStatus_ticketsStatusContent__-1n7f","info":"TicketsStatus_info__AeQjQ","dot":"TicketsStatus_dot__Y-dt0"};